<template>
  <div class="doc_max" v-if="showPageInfo">
    <div class="top">
      <div class="title">{{ doc.name }}</div>
      <div class="time">
        <i class="el-icon-timer"/>
        {{ doc.updateDate }}
      </div>
    </div>
    <div class="content" v-html="doc.apiDesc"></div>
  </div>
</template>

<script>

export default {
  name: 'doc',
  data () {
    return {
      doc: {},
      menu: []
    }
  },
  computed: {
    showPageInfo () {
      return this.$route.path.includes('openApi') && localStorage.getItem('openApiPartnerInfo')
    }
  },
  methods: {
    async getDocInfo () {
      this.doc = this.$store.getters.findById(this.$route.query.id)
      if (!this.doc || !this.doc.id) {
        await this.searchOpenApiInfos()
      }
    },
    async searchOpenApiInfos () {
      let jsonStr = localStorage.getItem('openApiPartnerInfo')
      if (jsonStr) {
        let info = JSON.parse(jsonStr)
        const {data: result} = await this.$http.get('/mini/searchOpenApiInfos', {headers: {accessToken: info.token}})
        if (result.code !== 200) return
        this.menu = result.data
        this.formatJSON()
        await this.$store.commit('setMenuList', result.data)
        this.doc = this.$store.getters.findById(this.$route.query.id)
      }
    },
    formatJSON () {
      this.menu.forEach(item => {
        item.openApiList.forEach(i => {
          if (i.type === 1) {
            this.$set(i, 'requestParams', this.formatArr(i.requestParams))
            this.$set(i, 'responseBody', this.formatArr(i.responseBody))
            this.$set(i, 'requestExample', this.formatObj(i.requestExample))
            this.$set(i, 'responseExample', this.formatObj(i.responseExample))
          }
        })
      })
    },
    formatObj (str) {
      if (!str) return {}
      try {
        return JSON.parse(str)
      } catch (e) {
        return {}
      }
    },
    formatArr (str) {
      if (!str) return []
      try {
        return JSON.parse(str)
      } catch (e) {
        return []
      }
    }
  },
  watch: {
    '$route.query': {
      handler (val) {
        if (this.$route.path.includes('doc')) {
          this.getDocInfo()
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped lang="less">
.doc_max {
  background-color: #fff;
  user-select: text !important;
  padding: 20px;

  & /deep/ p {
    margin-bottom: 12px !important;
  }

  & /deep/ h1,
  & /deep/ h2,
  & /deep/ h3,
  & /deep/ h4,
  & /deep/ h5,
  & /deep/ h6,
  & /deep/ b,
  & /deep/ strong {
    margin-bottom: 10px !important;
    font-weight: bolder !important;
  }

  .top {
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 25px;

    .title {
      font-size: 28px;
      font-weight: bolder;
    }

    .time {
      margin-top: 15px;
      color: #d6c0d6;
    }
  }

  .content {
    margin-top: 25px;

    .MsoTableGrid /deep/ .MsoNormal {
      margin-bottom: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newWebsite/main/components/doc.vue